// What a finalized invoice still owes, as one word for a badge. The balance is the
// repository's: total − active payments − finalized credit notes.

export type PaymentStatus = 'paid' | 'partial' | 'unpaid' | 'overdue'

export const PAYMENT_LABELS: Record<PaymentStatus, string> = {
  paid: 'Paid',
  partial: 'Part paid',
  unpaid: 'Unpaid',
  overdue: 'Overdue',
}

/**
 * Nothing owed (or a refund due) is paid; money owed past its due date is overdue
 * whether or not part was paid; otherwise part paid or unpaid. `today` and
 * `dueDate` are ISO days.
 */
export function paymentStatus(
  totalPaisa: number,
  balancePaisa: number,
  dueDate: string | null,
  today: string,
): PaymentStatus {
  if (balancePaisa <= 0) return 'paid'
  if (dueDate && dueDate.slice(0, 10) < today) return 'overdue'
  return balancePaisa < totalPaisa ? 'partial' : 'unpaid'
}
